// extracted by mini-css-extract-plugin
module.exports = {"career":"CareerSection_career__hMfCY","title":"CareerSection_title__zh78A"};